/* eslint-disable */
// Define assets path "On The Fly"
// Must be included here due to wrong assets path when missing
import {getPurchaseLink} from './purchase';

__webpack_public_path__ = window.inx.params.project.path.assets;
/* eslint-enable */

import urlParse from 'url-parse';

// NOTE: Initialize site-wide functions in this file
import { getComputedFontSize } from 'src/js/utils';
import {isOptionsPageNavigation, prefixStorageKeys} from 'newJs/utils';
import { STORAGE_KEY_NAMES } from 'newJs/config';
import initPurchaseModals from 'src/js/modules/purchase';
import prepareMapiUrls from 'src/js/configs/mapi';
import MainNavToolbar from 'newJs/containers/MainNavbar/MainNavToolbar';

const { FOLDERS_LIST } = STORAGE_KEY_NAMES;

const loadOptions = async () => await import(
    /* webpackChunkName: "module_options-left-aside" */
    './options-pages'
);

export default (inx, INBOX) => {
    // console.log(inx);
    const {
        toolBar,
        mail = {},
        params: {
            mapiFetchInterval, mapiHost, purchase, user
        }
    } = inx;
    const mailParams = mail?.params;
    const dataStorage = prefixStorageKeys();

    // Prepare MAPI methods
    INBOX.namespace('store', () => {
        return {
            dataStorage,
            MAPI: ((mapiHost, userEmail) => {
                const
                    { methods: v1Methods, ...rest } = prepareMapiUrls(mapiHost, userEmail),
                    { methods: v2Methods } = prepareMapiUrls(mapiHost, userEmail, 'v2');
                return {
                    fetchInterval: mapiFetchInterval,
                    v1: v1Methods,
                    v2: v2Methods,
                    ...rest
                };
            })(mapiHost, user.email),
            map: new Map(),
        };
    });

    // Show main nav bar in prefs
    if (mail.mainNav && isOptionsPageNavigation()) {
        const { containerId = 'js-options-page' } = mail.mainNav;
        const mainNavBarContainer = document.getElementById(containerId);
        if (mainNavBarContainer) MainNavToolbar(mainNavBarContainer, inx, INBOX);
    }

    // On user logout delete cached folders data from local storage
    if (user) {
        const { asideID } = toolBar.selectors;
        window.addEventListener('storage', () => {
            const quotaUserStorage = JSON.parse(localStorage.getItem('quota-user'));
            if (!quotaUserStorage) {
                setTimeout(() => window.location.reload(), 1000);
            }
        });
        const logoutElm = document.querySelector(`${asideID} .logout_link`);
        if (logoutElm) {
            logoutElm.addEventListener('click', () => {
                dataStorage.remove(FOLDERS_LIST);
                dataStorage.remove('quota-user');
            });
        }
    }

    // Menu for Options pages
    const pageHasSection = document.querySelector('section');
    if (pageHasSection?.classList.contains('options')) {
        if (mailParams?.optionsAside) {
            loadOptions().then(({ default: init }) => init({
                ...mailParams.optionsAside,
                bodyFontSize: getComputedFontSize(),
            }));
        }
    }

    // Show purchase form modal if required
    if (typeof purchase === 'object') {
        const trialData = {
            i18nTrial: inx.i18n.trial,
            i18nExpires: inx.i18n.expires,
            defaultDomain: inx.params.defaultDomain,
            userDomain: inx.params.user.domain,
            product: inx.i18n.product
        };

        const purchaseLink = getPurchaseLink({
            utm_content: 'mail',
            utm_campaign: 'billing_page',
            utm_term: 'popup_premium_expire',
        });

        initPurchaseModals({
            params: { ...inx.params.purchase, ...trialData, purchaseLink },
            pageAutoRefresh: (INBOX.store && INBOX.store.pageAutoRefresh) || false
        });

        const parsedUrl = urlParse(location.href, true);
        if (parsedUrl.query && parsedUrl.query.showPurchaseForm === 'true') {
            window.open(purchaseLink, '_blank');
        }
    }
};
